import ContainerView from "./container";

export default ContainerView.extend({
    tagName: "div",
    className: "navbar",
    idPrefix: "toolbar-",
});
